module.exports = __webpack_public_path__ + "static/media/more.e77c851c.svg";